<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ppp-differentpaths004htmlded">
<p class="ct"><a class="xref" href="#/OEBPS/pppdifferentpaths006#ppp-differentpaths006htmltoc">Dedication</a></p>
<p class="ded">For all who have loved and supported Stella<br class="calibre1"/>from the beginning. May you find the love, loyalty,<br class="calibre1"/>and integrity she finds central to living a good life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-differentpaths004.vue?71fffc24